import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/authContext";
import createAxiosInstance from "../../../utils/axiosConfig";
import {
	defaultColumns,
	defaultGovernanceColumns,
} from "../../../utils/constants";
import { get_form_data } from "../../../utils/endpoints";
import AdminTables from "../../common/adminTables";
import AdminLayout from "../../common/adminLayout";
import { Alert as AlertType } from "../../../utils/interfaces";

const ViewFormData = () => {
	const navigate = useNavigate();
	const { userData, logout } = useAuth();
	const [formData, setFormData] = useState<{
		results: [];
		total_count: number;
	}>({ results: [], total_count: 0 });
	const [useCase, setUseCase] = useState("use_case_3");
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(3);
	const [isLoading, setIsLoading] = useState(true);
	const [alert, setAlert] = useState<AlertType | null>(null);

	const handleApiError = (error: any, message: string = "An error occurred") => {
		if (error.status == 401 || error.status == 403) {
			logout();
			navigate("/");
		}
		console.error(message, error);
	};

	const getFormData = async () => {
		try {
			setIsLoading(true);
			const response = await createAxiosInstance().post(get_form_data, {
				usecase: useCase,
				offset: (currentPage - 1) * itemsPerPage,
				limit: itemsPerPage,
			});
			setFormData(response.data);
		} catch (error: any) {
			handleApiError(error, "Error loading form data");
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getFormData();
	}, [useCase, currentPage, itemsPerPage]);

	useEffect(() => {
		if (userData && !userData?.is_admin) {
			navigate("/");
		}
	}, [userData]);

	// Action panel component for use case selection
	const UseCaseSelector = () => (
		<>
			<label htmlFor="floatingSelect">Select a use case:</label>
			<select
				value={useCase}
				onChange={(e) => setUseCase(e.target.value)}
				className="form-select bg-white"
				id="floatingSelect"
				aria-label="Floating label select example"
			>
				<option value="use_case_3">Use Case 3</option>
				<option value="use_case_7">Use Case 7</option>
			</select>
		</>
	);

	return (
		<AdminLayout
			title="Form Data"
			actionPanel={<UseCaseSelector />}
			formData={formData}
			currentPage={currentPage}
			setCurrentPage={setCurrentPage}
			itemsPerPage={itemsPerPage}
			setItemsPerPage={setItemsPerPage}
			alert={alert || undefined}
			setAlert={setAlert}
		>
			<AdminTables
				containerStyle={{
					width: "100%",
					overflowX: "auto",
					marginTop: '0.8rem'
				}} 
				data={formData?.results}
				columns={
					useCase === "use_case_3"
						? defaultColumns
						: defaultGovernanceColumns
				}
				rowSelectionEnabled={false}
				showSearch={false}
				onRowSelect={() => {}}
				isLoading={isLoading}
			/>
		</AdminLayout>
	);
};

export default ViewFormData;
